import { useEffect, useRef, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { useParams } from 'react-router';
import { OPEN_APP } from '~components/AppCta';
import { Mark } from '~components/Logo';
import { shared } from '~styles';
import { styles } from './styles';
type Result = {
  ok: boolean;
  channel?: 'EMAIL' | 'PHONE';
};

// Landing for contact-verification links from email/SMS. The token is consumed
// via POST (never on the GET — email scanners prefetch links), served by the
// rest process on the same host.
export function Verify() {
  const {
    token = ''
  } = useParams();
  const [result, setResult] = useState<Result | null>(null);
  const requested = useRef(false);
  useEffect(() => {
    if (requested.current) return;
    requested.current = true;
    fetch(`${process.env.REST_URL}/verify/${token}`, {
      method: 'POST'
    }).then(res => res.json() as Promise<Result>).then(setResult).catch(() => setResult({
      ok: false
    }));
  }, [token]);
  if (!result) {
    return <main {...stylex.props(styles.container)}>
        <p {...stylex.props(shared.muted)}>Verifying…</p>
      </main>;
  }
  const contact = result.channel === 'PHONE' ? 'Phone' : 'Email';
  return <main {...stylex.props(styles.container)}>
      <Mark size={56} />
      {result.ok ? <>
            <h1 {...stylex.props(styles.title)}>{contact} verified!</h1>
            <p {...stylex.props(shared.muted, styles.lead)}>
              You&apos;re all set — head back to the Tribys app.
            </p>
            <a {...stylex.props(shared.primaryButton)} href={OPEN_APP}>
              Open the Tribys app
            </a>
          </> : <>
            <h1 {...stylex.props(styles.title)}>This link is no longer valid</h1>
            <p {...stylex.props(shared.muted, styles.lead)}>
              The verification link has expired or was already used. Request a
              new one from the app.
            </p>
            <a {...stylex.props(shared.primaryButton)} href={OPEN_APP}>
              Open the Tribys app
            </a>
          </>}
    </main>;
}